import {useDispatch, useSelector} from "react-redux";
import {useEffect, useMemo} from "react";
import {API} from "@brg/api";
import {useTranslation} from "react-i18next";
import {LMSActions, loadLMSDisciplines, selectorLMS} from "../../../reducers/LMSSlice";
import {IDiscipline, IDisciplineOption} from "../../../constants/courses/IDiscipline";

const getCurrentItemInTeamList = (item: any, teamId?: string) => {
    if (Object.keys(item).includes(teamId || '')) {
        return item[teamId || '']
    }
    return null;
}

export const useGetLMSDisciplines = (teamId?: string, disabled?: boolean) => {
    const dispatch = useDispatch()
    const { i18n: {language} } = useTranslation();

    const selector = useSelector(selectorLMS);

    useEffect(() => {
        if (!disabled) {
            dispatch(loadLMSDisciplines({ teamId: teamId || '' }))
            dispatch(LMSActions.addLMSDisciplinesTeamId(teamId || ''))
        }
    }, [teamId]);

    useEffect(() => {
        if (!selector.isLoading) {

        }
    }, [selector])

    const disciplinesRaw = useMemo(() => getCurrentItemInTeamList(selector?.lmsDisciplines, teamId) || [] as IDiscipline<'Global'>[], [selector, language, teamId])
    const disciplines = useMemo(() => API.toLang(getCurrentItemInTeamList(selector?.lmsDisciplines, teamId) || [], language) as IDiscipline<'Local'>[], [selector, language, teamId])
    const options = useMemo(() => {
        const result = API.toLang(getCurrentItemInTeamList(selector?.lmsDisciplinesOptions, teamId) || [], language) as IDisciplineOption<'Local'>[]
        if (!result || result.length === 0) return [{value: '', label: ''}]
        return result
    }, [selector, language, teamId])
    const colors = useMemo(() => API.toLang(getCurrentItemInTeamList(selector?.lmsDisciplinesColors, teamId) || {}, language) as {[key: string]: string}, [selector, language, teamId])
    const loading = useMemo(() => selector?.loading, [selector])

    return {disciplines, disciplinesRaw, options, colors, loading}
}import {useDispatch, useSelector} from "react-redux";
import {useEffect, useMemo} from "react";
import {API} from "@brg/api";
import {useTranslation} from "react-i18next";
import {LMSActions, loadLMSDisciplines, selectorLMS} from "../../../reducers/LMSSlice";
import {IDiscipline, IDisciplineOption} from "../../../constants/courses/IDiscipline";

const getCurrentItemInTeamList = (item: any, teamId?: string) => {
    if (Object.keys(item).includes(teamId || '')) {
        return item[teamId || '']
    }
    return null;
}

export const useGetLMSDisciplines = (teamId?: string, disabled?: boolean) => {
    const dispatch = useDispatch()
    const { i18n: {language} } = useTranslation();

    const selector = useSelector(selectorLMS);

    useEffect(() => {
        if (!disabled) {
            dispatch(loadLMSDisciplines({ teamId: teamId || '' }))
            dispatch(LMSActions.addLMSDisciplinesTeamId(teamId || ''))
        }
    }, [teamId]);

    useEffect(() => {
        if (!selector.isLoading) {

        }
    }, [selector])

    const disciplinesRaw = useMemo(() => getCurrentItemInTeamList(selector?.lmsDisciplines, teamId) || [] as IDiscipline<'Global'>[], [selector, language, teamId])
    const disciplines = useMemo(() => API.toLang(getCurrentItemInTeamList(selector?.lmsDisciplines, teamId) || [], language) as IDiscipline<'Local'>[], [selector, language, teamId])
    const options = useMemo(() => {
        const result = API.toLang(getCurrentItemInTeamList(selector?.lmsDisciplinesOptions, teamId) || [], language) as IDisciplineOption<'Local'>[]
        if (!result || result.length === 0) return [{value: '', label: ''}]
        return result
    }, [selector, language, teamId])
    const colors = useMemo(() => API.toLang(getCurrentItemInTeamList(selector?.lmsDisciplinesColors, teamId) || {}, language) as {[key: string]: string}, [selector, language, teamId])
    const loading = useMemo(() => selector?.loading, [selector])

    return {disciplines, disciplinesRaw, options, colors, loading}
}